import _ from 'lodash'
import {Message} from 'element-ui'
import $ from 'jquery'
import {utils} from "./index";
import {ID_CARD_REG} from "@/store/constant";
import {Notification} from "element-ui";

let flag = false;
const pattern = /\/[A-Za-z-_]+[0-9]?/g;
const decode = decodeURIComponent;
export default {
  isNumber: function (n) {
    return !isNaN(parseFloat(n)) && isFinite(n);
  }
  , isNotNumber: function (n) {
    return !this.isNumber(n);
  }
  , toDecimal2: function (x) {
    let b = parseFloat(x);
    if (isNaN(b)) {
      return "";
    }
    let f = Math.round(x * 100) / 100;
    let s = f.toString();
    let rs = s.indexOf('.');
    if (rs < 0) {
      rs = s.length;
      s += '.';
    }
    while (s.length <= rs + 2) {
      s += '0';
    }
    return s;
  }
  /**
   * 出租类型显示 xxx 元/月
   * 出售类型显示 xxx 万元(如果大于10000)
   * @param price
   * @param sign
   * @returns {*}
   */
  , priceFormat(price, sign) {
    if (!this.isNumber(price)) return price;
    if (!this.isNumber(sign)) return price;
    if (price > 9999 && sign / 1 === 0) {
      return this.toDecimal2(price / 10000) + "万元"
    }
    return (this.toDecimal2(price) || "") + "元/月"
  }

  /**
   * 递归查找左侧菜单中是否包含某个 object
   * @param data menus 这是一个数组
   * @param item 一个查询条件,例如: {id:'1'}或者{route:'/home'}
   * @returns {*}
   */
  , exitInMenus(data, item, notInit) {
    if (!notInit) flag = false
    if (!(data instanceof Array)) return null
    let i = 0
    while (i < data.length) {
      let target = data[i]

      if (flag) {
        break
      }
      if (_.isMatch(target, item)) {
        return target
      } else {
        if (target.menuPermission instanceof Array) {
          //此时用flag接住，如果递归找到，flag为true，否则为null
          flag = this.exitInMenus(target.menuPermission, item, true)
        }
      }
      i++
    }

    if (flag) {
      //重置flag，为下次查找初始化flag
      return flag
    } else {
      return null
    }
  }

  /**
   * exitInMenus 函数的变种,因为exitInMenus无法满足查找第一个url不为#的菜单.
   */
  , firstMenu(data, notInit) {
    if (!notInit) flag = false
    if (!(data instanceof Array)) return null
    let i = 0
    while (i < data.length) {
      let target = data[i]
      if (flag) {
        break
      }
      if (target.type == 1 && target.url.trim() != "#") {
        return target
      } else {
        if (target.menuPermission instanceof Array) {
          flag = this.firstMenu(target.menuPermission, true)
        }
      }
      i++
    }

    if (flag) {
      //重置flag，为下次查找初始化flag
      return flag
    } else {
      return null
    }
  }
  , isEmpty: function (obj) {
    if (typeof obj === "undefined" || obj === null || obj === "") {
      return true;
    } else {
      return false;
    }
  }
  , isNotEmpty: function (obj) {
    return !this.isEmpty(obj);
  }
  , getBreadcrumbs(data, id) {
    for (let i = 0; i < data.length; i++) {
      const element = data[i]
      if (element.id == id) {
        return element.breadcrumbs
      }
    }
  }
  , combMenu(arr, menulist, breadcrumbs) {
    // 循环菜单
    arr.forEach(menu => {
      // 如果存在子菜单
      if (menu.menuPermission && menu.menuPermission.length > 0) {
        // 创建子菜单的面包屑
        let bcs = []
        if (breadcrumbs) {
          bcs = [...breadcrumbs]
        }
        bcs.push(menu.name)
        // 连击子菜单
        this.combMenu(menu.menuPermission, menulist, bcs)
      }
      // 将菜单接口中的所有数据插入到菜单数组中
      if (breadcrumbs) {
        menu.breadcrumbs = [...breadcrumbs, menu.name]
      } else {
        menu.breadcrumbs = [menu.name]
      }
      menulist.push(menu);
    });
  }
  , getRoute(str) {
    if (this.isEmpty(str)) return {};
    let routes = str.match(pattern);
    let appPath = routes.shift();
    let menuPath = routes.join('');

    return {appPath, menuPath, source: str}
  }

  , getRouteReg() {
    return pattern
  }

  /**
   * 将 location 的 query 转换成对象
   * @param query
   */
  , parseQuery(query) {
    let res = {};

    query = query.trim().replace(/^(\?|#|&)/, '');

    if (!query) {
      return res
    }

    query.split('&').forEach(function (param) {
      let parts = param.replace(/\+/g, ' ').split('=');
      let key = decode(parts.shift());
      let val = parts.length > 0
        ? decode(parts.join('='))
        : null;

      if (res[key] === undefined) {
        res[key] = val;
      } else if (Array.isArray(res[key])) {
        res[key].push(val);
      } else {
        res[key] = [res[key], val];
      }
    });

    return res
  }

  , parsePath(path) {
    let hash = '';
    let pathArr = path.split('?');
    let hashStr = pathArr.shift();
    let query = pathArr.pop() || '';

    let hashIndex = hashStr.indexOf('#');
    if (hashIndex >= 0) {
      hash = hashStr.slice(hashIndex + 1);
    } else {
      hash = hashStr
    }


    return {
      query: query,
      hash: hash
    }
  }
  , getQueryParams(key) {
    let result = '',
      name,
      str = location.hash, //取得整个地址栏
      num = str.indexOf('?');
    // endStr = str.indexOf('#'),
    // end = endStr < 1 ? str.length : endStr;
    str = str.substring(num + 1) //取得所有参数   stringvar.substr(start [, length ]
    let arr = str.split('&') //各个参数放到数组里
    for (let i = 0; i < arr.length; i++) {
      num = arr[i].indexOf('=')
      if (num > 0) {
        name = arr[i].substring(0, num)
        name == key ? result = arr[i].substr(num + 1) : ''
      }
    }
    return result
  }
  , getDomain(url) {
    if (this.isEmpty(url)) {
      return '';
    }
    if (url.indexOf('//') > -1) {
      let arrUrl = url.split('//');
      let end = arrUrl[1].indexOf('/') + 1;
      let domain = arrUrl[1].substring(0, end);
      let other = arrUrl[1].substring(end);
      // 是否是访问测试环境的jcp
      if (other.indexOf('jcp') > -1) {
        domain += 'jcp/'
      }
      return arrUrl[0] + '//' + domain
    }
    return ''
  }
  , validatePhone(rule, value, callback) {
    if (/^1[0-9]{10}$/.test(value)) {
      callback()
    } else {
      callback(new Error('请输入正确的手机号码'))

    }
  },
  /**
   * 支持手机号和固定电话
   */
  validatePhone1(rule, value, callback) {
    if (/^1[0-9]{10}$/.test(value) || /^(([0-9]{7,8})||((\d{3,4}-)?\d{7,8}))$/.test(value)) {
      callback();
    } else {
      callback(new Error("请输入正确的手机号或者固定电话"))
    }
  }
  , validateCardNo(rule, value, callback) {
    if (utils.isEmpty(value)) {
      callback(new Error("请输入身份证号码!"));
    }
    if (ID_CARD_REG.test(value)) {
      callback();
    } else {
      callback(new Error("证件号格式错误！"));
    }
  }
  , validateTelephone(rule, value, callback) {
    if (/^[0-9]{7,8}$/.test(value)) {
      callback()
    } else {
      callback(new Error('请输入正确的固定电话号码'))
    }
  }
  , validateAreaCode(rule, value, callback) {
    if (/^[0-9]{3,4}$/.test(value)) {
      callback()
    } else {
      callback(new Error('请输入正确的区号'))
    }
  },
  /**
   * 判断空对象
   * @param {*} rule
   * @param {*} value
   * @param {*} callback
   */
  validateEmptyObject(rule, value, callback) {
    if (Object.keys(value).length == 0) {
      callback(new Error("必填项"))
    } else {
      callback()
    }
  },
  /**
   * 只能是单纯的字符
   * @param rule
   * @param value
   * @param callback
   */
  validateCharacterOnly(rule, value, callback) {
    if (/^[A-Za-z]+$/.test(value)) {
      callback()
    } else {
      callback(new Error('请输入正确的字母'))
    }
  },
  downloadByIframe(url, data) {
    if (this.isEmpty(url)) return Message.warning('没有传入导出地址');
    let $form = $('form[name="wholeExportForm"]');
    $form.attr('action', url);
    for (let o in data) {
      let input = document.createElement("input");
      input.name = o;
      input.value = data[o];
      $form.append(input);
    }

    $form.submit();
    $form.find('input').remove();
  }
}

export function reject(msg) {
  Notification.warning(msg)
  return Promise.reject(msg)
}
